/// <amd-module name="Pipeline/Analytics/PipelineOutcome/FailureTrendCard/Common/PipelineOutcomeChartSeries" />
import * as ChartSeries from "Analytics/Shared/ChartSeries/ChartSeries";
import * as Resources from "Pipeline/Analytics/PipelineOutcome/FailureTrendCard/Resources";

export class PipelineFailureTrendSeries extends ChartSeries.ChartSeries {
    public get name(): string {
        return Resources.FailedPipelines;
    }

    public get color(): string {
        return PipelineFailedColorPalette;
    }

    public get values(): number[] {
        return this._data;
    }
}

const PipelineFailedColorPalette = "#DA0A00";
